import React from 'react';

const FounderNote = () => {
    return (
        <div className="">
            <div
                className="text-center p-5"
                style={{ backgroundColor: '#EE4358', color: 'white', borderRadius: '8px' }}
            >
                <div className="d-flex align-items-center justify-content-center mb-3">
                </div>
                <h2 className="fw-bold">A Note from Our Founder</h2>
                <p className="fw-light" style={{ fontStyle: 'italic' }}>
                    Here is why I started this Agarwal's Paying Guest...
                </p>
                <p className="mt-4">
                    Growing up and later living away from home for studies and work, I experienced firsthand how difficult
                    it can be to find a safe, comfortable, and trustworthy place to stay. Many accommodations looked good
                    on paper but lacked cleanliness, care, or a sense of belonging.
                </p>
                <p>
                    Over time, I realized that paying guest living should be more than just a room—it should feel like home.
                    A place where students and working professionals feel secure, respected, and comfortable while focusing
                    on their goals.
                </p>
                <p>
                    That belief led to the foundation of our Agarwal's Paying Guest. By focusing on cleanliness,
                    transparency, essential amenities, and personal care, we aim to create a stress-free living experience
                    for every resident.
                </p>
                <p>
                    Our mission is simple: to provide a home away from home, built on trust, comfort, and care.
                    That is what drives us every day.
                </p>
            </div>
        </div>

    );
};

export default FounderNote;
